import { Col, Row } from "reactstrap";
import { BlogDetailsTitle } from "../../../../Constants/Constants";
import { dynamicImage, Image } from "../../../../Utils";
import LatestBlog from "./LatestBlog";
import LeaveComment from "./LeaveComment";

const BlogDetails = () => {
  const BlogText = "From the east coast to the west, each river has its own beauty and character. Each river has its own story. Take a look at some America’s best rivers and some of the rivers we’re working to protect. ";
  return (
    <Row>
      <Col lg="12">
        <div className="blog-box">
          <Image className="img-fluid w-100 rounded" src={dynamicImage("blog/1.jpg")} alt="blog" />
          <div className="blog-details">
            <p className="pt-3 mb-2">{"25 July 2024"}</p>
            <h4 className="pb-2">{BlogDetailsTitle}</h4>
            <p className="mb-2">{BlogText}</p>
          </div>
        </div>
      </Col>
      <LatestBlog />
      <LeaveComment/>
    </Row>
  );
};

export default BlogDetails;
